
import { onMounted, reactive, ref } from "vue";
import axios from "axios";
import { useRoute, useRouter } from 'vue-router';
export default {
     name:"AdminRiderraterangeEdit",
 setup() {
    const data  =reactive({
        start_range:'',
        end_range:'',
        range_price:'',
        rate_type:'',
        rate_price_type:''
              

    });
   
      const router = useRouter();
      const route = useRoute();
     
   const riderrate_id = ref([]);

    onMounted(async ()=>{
      
      const response = await axios.get(`/riderrateranges/${route.params.id}`);
      
        data.start_range =response.data.start_range;
        data.end_range =response.data.end_range;
        data.range_price =response.data.range_price;
        data.rate_type=response.data.rate_type;
        data.rate_price_type=response.data.rate_price_type;
        riderrate_id.value = response.data.riderrate.id;

        
    });

const submit =async ()=>{

await axios.put(`/riderrateranges/${route.params.id}`,data);

  await router.push(`/riderrates/detail/${riderrate_id.value}`);
}


    return {
        data,
        
      submit
    };
  },
};
